import type { ConfirmationsTranslations } from "../interfaces/confirmations";

export const confirmationsTranslations: ConfirmationsTranslations = {
  page_title: "Confirmações de Pagamentos",
  button_new_confirmation: "Nova Confirmação",
  toast_error_load: "Erro ao carregar confirmações",
  toast_error_load_more: "Erro ao carregar mais confirmações",
  toast_success_create: "Confirmação criada corretamente",
  toast_error_create: "Erro ao criar a confirmação",
  toast_success_cancel: "Confirmação cancelada corretamente",
  toast_error_cancel: "Erro ao cancelar a confirmação",
  toast_success_confirm: "Confirmação realizada corretamente",
  toast_warning_attachment: "Confirmação realizada, mas não foi possível enviar a evidência.",
  toast_error_confirm: "Erro ao confirmar a transação",
  toast_success_notify: "Cliente notificado corretamente",
  toast_error_notify: "Erro ao notificar o cliente",
  toast_success_taker_reminder: "Lembrete enviado com sucesso",
  toast_error_taker_reminder: "Erro ao enviar o lembrete",
  toast_no_image: "Não há imagem para abrir em nova aba",
  loading: "Carregando…",
  show_more: "Mostrar mais",
  alt_comprobante_pago: "Comprovante de pagamento",
  alt_comprobante_confirmacion: "Comprovante de confirmação",

  card_status_pending: "Pendente",
  card_status_confirmed: "Confirmado",
  card_label_note: "Nota:",
  card_label_created_by: "Criado por:",
  card_label_updated_by: "Atualizado por:",
  card_label_created_at: "Data de criação:",
  card_label_updated_at: "Data de atualização:",
  card_button_notify_client: "Cliente notificado",
  card_button_taker_reminder: "Dar um toque",
  card_button_cancel: "Cancelar",
  card_button_confirm: "Confirmar",
  card_button_view_history: "Ver histórico",
  card_verified: "Verificado",
  card_button_view: "Ver",
  card_button_open: "Abrir",
  card_loading: "Carregando…",
  card_error_load: "Erro ao carregar",
  card_alt_comprobante: "Comprovante",
  card_alt_comprobante_n: "Comprovante {{n}}",

  board_empty_title: "Não há confirmações de pagamento",
  board_empty_description:
    "As confirmações que você criar ou receber aparecerão aqui. Use o botão «Nova confirmação» para registrar um comprovante de pagamento.",
  column_pending: "Pendentes",
  column_confirmed: "Confirmados",
  column_empty_pending: "Não há confirmações pendentes. As novas confirmações aparecerão aqui.",
  column_refresh: "Atualizar",
  column_refresh_aria: "Atualizar confirmações",
  column_drag_to_confirm: "Arraste para confirmar",

  modal_cancel_title: "Cancelar confirmação de pagamento",
  modal_cancel_description:
    "Por favor, indique o motivo pelo qual deseja cancelar esta transação. Esta ação não pode ser desfeita após confirmada.",
  modal_cancel_label_reason: "Motivo do cancelamento",
  modal_cancel_placeholder: "Escreva aqui o motivo do cancelamento...",
  modal_cancel_back: "Voltar",
  modal_cancel_confirm: "Confirmar cancelamento",
  modal_cancel_confirming: "Cancelando...",
  modal_cancel_required: "O motivo do cancelamento é obrigatório.",
  modal_cancel_close_aria: "Fechar",

  modal_new_title: "Nova confirmação de pagamento",
  modal_new_submit: "Criar solicitação",
  modal_new_cancel: "Cancelar",

  modal_confirm_title: "Confirmar transação",
  modal_confirm_description:
    "Tem certeza que deseja confirmar esta transação? Esta ação será registrada no histórico.",
  modal_confirm_source_label: "Ingresso de banco",
  modal_confirm_source_placeholder: "Selecione o ingresso de banco",
  modal_confirm_source_required: "O ingresso de banco é obrigatório.",
  modal_confirm_attach_evidence: "Anexar evidência",
  modal_confirm_no_attachments: "Não enviar anexos",
  modal_confirm_evidence_label: "Evidência (imagens)",
  modal_confirm_evidence_description: "PNG, JPG, WebP até 10 MB. Você pode escolher vários arquivos.",
  modal_confirm_evidence_instruction: "Clique para selecionar ou arraste arquivos aqui",
  modal_confirm_back: "Voltar",
  modal_confirm_confirm: "Confirmar",
  modal_confirm_evidence_required: "É necessário anexar pelo menos um comprovante.",
  modal_confirm_close_aria: "Fechar",

  modal_client_notified_title: "Cliente notificado",
  modal_client_notified_description:
    "O cliente foi notificado sobre esta confirmação de pagamento. A notificação fica registrada no histórico.",
  modal_client_notified_close: "Fechar",
  modal_client_notified_confirm: "Confirmar",
  modal_client_notified_close_aria: "Fechar",

  modal_history_title: "Detalhe da confirmação de pagamento",
  modal_history_loading: "Carregando histórico…",
  modal_history_error: "Não foi possível carregar o histórico.",
  modal_history_empty: "Não há registros no histórico.",
  modal_history_section_title: "Histórico de alterações",
  modal_history_initial_status: "Estado inicial",
  modal_history_previous_status: "Estado anterior",
  modal_history_current_status: "Estado atual",
  modal_history_duration: "Duração",
  modal_history_close: "Fechar",
  modal_history_close_aria: "Fechar",
  status_pending: "Pendente",
  status_confirmed: "Confirmado",
  status_cancelled: "Cancelado",
  status_archived: "Arquivado",
  status_notified: "Notificado",
  change_type_created: "Criação",
  change_type_status: "Mudança de estado",
  change_type_data: "Atualização de dados",
  change_type_attachment: "Anexo adicionado",
  change_type_note: "Nota adicionada",

  form_label_client: "Cliente",
  form_placeholder_client: "Digite o nome do cliente",
  form_checkbox_same_client: "Beneficiário é o mesmo cliente",
  form_label_beneficiary: "Beneficiário",
  form_placeholder_beneficiary: "Beneficiário",
  form_label_amount: "Valor",
  form_label_currency: "Tipo de moeda",
  form_placeholder_currency: "Selecionar moeda...",
  form_label_bank: "Banco",
  form_placeholder_bank: "Selecionar método de pagamento...",
  form_placeholder_bank_currency_first: "Selecione primeiro uma moeda",
  form_label_date: "Data",
  form_label_note: "Nota",
  form_placeholder_note: "Adicionar uma nota a esta confirmação...",
  form_label_comprobante: "Comprovante (imagem)",
  form_comprobante_description: "PNG, JPG, WebP até 10 MB",
  form_comprobante_instruction: "Clique para enviar ou arraste aqui",
  form_comprobante_instruction_drop: "Solte o arquivo aqui",
  form_comprobante_size_format: "Máximo {{max}} MB • Imagens (JPG, PNG, WebP)",
  form_comprobante_preview_alt: "Visualização do comprovante",
  form_comprobante_change: "Alterar",
  form_comprobante_remove: "Remover",

  validation_cliente_required: "O nome do cliente é obrigatório.",
  validation_pagador_required: "O nome do pagador é obrigatório.",
  validation_monto_invalid: "Digite um valor válido maior que zero.",
  validation_banco_required: "O banco é obrigatório.",
  validation_moneda_required: "O tipo de moeda é obrigatório.",
  validation_fecha_required: "A data é obrigatória.",
  validation_comprobante_required: "O comprovante é obrigatório.",
};
